export default __webpack_public_path__ + "images/logo-light.9475d1a61892cce75022b8bc69c7270d.png";